import { motion } from "framer-motion";
import { EASE } from "./config";

export const MaskLines = ({ lines, className = "", delay = 0.15, accentIndex = -1, testId }) => (
  <h1 className={`font-display ${className}`} data-testid={testId}>
    {lines.map((line, i) => (
      <span key={line} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${i === accentIndex ? "text-[var(--dash)]" : ""}`}
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Rise = ({ children, delay = 0, className = "", y = 24, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ index, children }) => (
  <div className="flex items-center gap-3 font-mono-d text-[11px] uppercase tracking-[0.28em] text-zinc-400">
    <span className="text-[var(--dash)]">{index}</span>
    <span className="h-px w-8 bg-zinc-700" />
    <span>{children}</span>
  </div>
);

export const SlideShell = ({ children, testId, className = "" }) => (
  <div
    data-testid={testId}
    className={`relative mx-auto flex min-h-full w-full max-w-[1440px] flex-col px-5 pb-28 pt-20 sm:px-8 lg:h-full lg:px-14 lg:pb-24 lg:pt-[5.5rem] ${className}`}
  >
    {children}
  </div>
);

export const DashMark = ({ className = "h-7 w-auto" }) => (
  <img src="/assets/dash-logo.svg" alt="Dash AI logo" className={className} />
);
